<template>
  <v-content>
    <!-- Content will be placed here -->
    <div
      class="nx-view"
      :class="customClassName"
    >
      <router-view />
    </div>
    <nx-app-toast />
    <nx-app-dialog />
  </v-content>
</template>

<script>
import NxAppDialog from '@/modules/app-dialog/AppDialog';
import NxAppToast from '@/modules/toast/Toast';

export default {
  name: 'Empty',
  components: {
    NxAppDialog,
    NxAppToast,
  },
  props: {
    customClassName: {
      type: String,
      default: 'primary',
    },
  },
};
</script>

<style lang="stylus">
@import '../assets/stylus/variables.styl'
.nx-view {
  min-height: 100vh;
}

</style>
